import JobMapGraphCardSupplierList from './JobMapGraphCardSupplierList';
export default JobMapGraphCardSupplierList;
